// Libs
import { createSelector } from 'reselect'

// Selectors
import getAllRequestsByStatus$ from './getAllRequestsByStatus'

// Constants
import { SUCCESS } from '../constants'

export default createSelector(
  getAllRequestsByStatus$(SUCCESS),
  (requests) => requests
)
